import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Hero } from '../components/Hero';
import { Products } from '../components/Products';
import { Story } from '../components/Story';
import { Community } from '../components/Community';
import { Testimonials } from '../components/Testimonials';
import { Retailers } from '../components/Retailers';
export function Home() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);
  return <main data-id="element-333">
      <Hero data-id="element-334" />
      <Products data-id="element-335" />
      <Story data-id="element-336" />
      <Community data-id="element-337" />
      <Testimonials data-id="element-338" />
      <Retailers data-id="element-339" />
    </main>;
}